import styled from 'styled-components';

export const ButtonAgendamentos = styled.button`
  width: 25px;
  height: 25px;
  text-align: center;
  border: 0;
  border-radius: 50%;
  color: #fff;
  background-color: #ffc107;
  padding-right: 1px;
`;

export const VerHistorico = styled.span`
  font-size: 13px;
  color: #007bff;
  :hover {
    cursor: pointer;
  }
`;
